import React from "react";
import GlobalStyle from "./globalStyles";
import styled from "styled-components";
import Home from "./pages/HomePage/Home";

import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";
import { Navbar, Footer } from "./components";

import "./App.css";

function App() {
  return (
    <Router>
      <GlobalStyle />
      <ScrollToTop />
      <Navbar />
      <Home />
      <Footer />
    </Router>
  );
}

export default App;
